import { Component, Input } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { stateURLs } from 'my-account/constants';

@Component({
    selector: 'xm-switch-banner',
    templateUrl: 'switch-banner.html',
    styleUrls: ['switch-banner.scss'],
    standalone: false
})
export class XmSwitchBannerComponent {
    @Input() public imageOptions: MediaImageOptions;
    @Input() public header: string;
    @Input() public description: string;
    @Input() public cta: {
        content: string;
        link: string;
    };

    private state: StateService;

    constructor(state: StateService) {
        Object.assign(this, { state });
    }

    public onCtaClick(): void {
        const stateUrl: string = stateURLs[this.cta.link];
        if (stateUrl) {
            this.state.go(stateUrl);
        }
    }
}
